import styled from "styled-components";

export const FloorPlanWrapper = styled.div``

export const FloorPlanImage = styled.img`
    width: 100%;
    border-radius: 1rem;
`